// extracted by mini-css-extract-plugin
export default {"projectContentContainer":"ProjectContent_projectContentContainer__zN4qx","subTopics":"ProjectContent_subTopics__Bip2u"};